/* eslint-disable @typescript-eslint/no-explicit-any */

import { createExercise } from '@datacamp/campus-integration';
import { constants, utils } from '@datacamp/remote-desktop-exercise-core';
import { applyMiddleware, compose, createStore } from 'redux';
import reduxThunk from 'redux-thunk';
import setExerciseEntity from './actions/actionCreators/exerciseEntityUpdated';
import Shell from './components/Shell';
import config, { USED_AS_SPA } from './config';
import { sentry } from './lib/sentry';
import commonDe from './locales/de-DE/common.json';
import glossaryDe from './locales/de-DE/glossary.json';
import de from './locales/de-DE/translation.json';
import commonEn from './locales/en/common.json';
import glossaryEn from './locales/en/glossary.json';
import en from './locales/en/translation.json';
import commonEs from './locales/es/common.json';
import glossaryEs from './locales/es/glossary.json';
import es from './locales/es/translation.json';
import commonFr from './locales/fr-FR/common.json';
import glossaryFr from './locales/fr-FR/glossary.json';
import fr from './locales/fr-FR/translation.json';
import commonIt from './locales/it-IT/common.json';
import glossaryIt from './locales/it-IT/glossary.json';
import it from './locales/it-IT/translation.json';
import commonPt from './locales/pt-BR/common.json';
import glossaryPt from './locales/pt-BR/glossary.json';
import pt from './locales/pt-BR/translation.json';
import commonTr from './locales/tr-TR/common.json';
import glossaryTr from './locales/tr-TR/glossary.json';
import tr from './locales/tr-TR/translation.json';
import reducers from './reducers';
function isDefinedObject(obj) {
  return typeof obj === 'object';
}
function hasExt(obj) {
  return !!obj;
}
const win = global;
const composeEnhancers = USED_AS_SPA && isDefinedObject(win) && hasExt(win.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ? win.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(reduxThunk)));
const App = createExercise({
  config,
  provideUserEventTracker: true,
  requireAuthenticatedUser: true,
  sentryInstance: sentry,
  setExerciseEntity,
  store,
  translations: {
    de: {
      common: commonDe,
      glossary: glossaryDe,
      translation: de
    },
    en: {
      common: commonEn,
      glossary: glossaryEn,
      translation: en
    },
    es: {
      common: commonEs,
      glossary: glossaryEs,
      translation: es
    },
    fr: {
      common: commonFr,
      glossary: glossaryFr,
      translation: fr
    },
    it: {
      common: commonIt,
      glossary: glossaryIt,
      translation: it
    },
    pt: {
      common: commonPt,
      glossary: glossaryPt,
      translation: pt
    },
    tr: {
      common: commonTr,
      glossary: glossaryTr,
      translation: tr
    }
  },
  type: constants.exercises.REMOTE_DESKTOP_EXERCISE,
  validate: utils.exerciseTypeVersionAdapter
})(Shell);
export default App;